import { ReactElement, useState } from "react";

export function useMultiPages(
  steps: ReactElement[],
  guard?: (nextIndex: number) => boolean,
) {
  const [currentStepIndex, setCurrentStepIndex] = useState(0);

  function nextPage() {
    setCurrentStepIndex((i) => {
      const nextIndex = i >= steps.length - 1 ? i : i + 1;
      if (guard && !guard(nextIndex)) return i;
      return nextIndex;
    });
  }

  function prevPage() {
    setCurrentStepIndex((i) => {
      const nextIndex = i <= 0 ? i : i - 1;
      if (guard && !guard(nextIndex)) return i;
      return nextIndex;
    });
  }

  function handleGoToPageIndex(index: number) {
    if (guard && !guard(index)) return;
    setCurrentStepIndex(index);
  }

  return {
    currentStepIndex,
    step: steps[currentStepIndex],
    steps,
    isFirstStep: currentStepIndex === 0,
    isLastStep: currentStepIndex === steps.length - 1,
    initialPage: currentStepIndex === 0,
    handleGoToPageIndex,
    nextPage,
    prevPage,
  };
}
